<template>
  <div
    class="standard-delete-button red mr-1 font-weight-light"
    :style="`
      ${value?'width: 66px !important; border-radius: 3px !important; ':''}
      ${value && direction === 'left'?'margin-left: -46px; ':''}
      zoom: ${zoom?zoom:'var(--taktplan_zoom); '}
    `"
    @mouseleave="value = false"
    @click.prevent.stop="
      value?
      $emit('clickDelete')
      :
      value = true
      "
    >
    <template v-if="value">
      <v-icon small>delete</v-icon>
      <div>{{$t('Buttons.Delete')}}</div>
    </template>
    <v-icon v-else small>close</v-icon>
</div>
</template>
<script>
  export default {
    props: ['direction', 'zoom'],
    data: () => ({
      value: false,
    }),
  }
</script>
<style>
  .standard-delete-button {
    display: flex;
    height: 20px !important;
    width: 20px !important;
    border-radius: 20px;
    color: white;
    justify-content: center;
    align-items: center;
    transition: width 0.1s ease-in-out, margin-left 0.1s ease-in-out, border-radius 0s 0.05s;
    cursor: pointer;
    overflow: hidden;
  }
</style>
